var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 221.16 93.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4,.cls-6{mix-blend-mode:screen;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:#99570e;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 32.82,
    x2: 221.16,
    y2: 32.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6c440f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6c440f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ffd66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 110.58,
    y1: 97.76,
    x2: 110.58,
    y2: 39.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd86c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 51.76,
    x2: 221.16,
    y2: 51.76,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 110.58,
    y1: 90.2,
    x2: 110.58,
    y2: 40.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc74e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff984d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 26.94,
    y1: 71.1,
    x2: 194.21,
    y2: 71.1,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.58,0C49.51,0,0,12.56,0,28.05V65.64H221.16V28.05C221.16,12.56,171.65,0,110.58,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 110.58,
    cy: 65.64,
    rx: 110.58,
    ry: 28.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.58,38.79c60.67,0,109.92,12.13,110.56,27.15,0-.1,0-.2,0-.3,0-15.49-49.51-28-110.58-28S0,50.15,0,65.64c0,.1,0,.2,0,.3C.66,50.92,49.91,38.79,110.58,38.79Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 110.58,
    cy: 65.64,
    rx: 83.67,
    ry: 21.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26.94,65c1.25,11.44,38.22,20.62,83.64,20.62S193,76.48,194.21,65c-.33-3-3.18-5.92-8-8.51C172.74,63.7,144,68.66,110.58,68.66S48.41,63.7,35,56.53C30.13,59.12,27.28,62,26.94,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M187.26,57.13c-12.93,7.49-42.39,12.73-76.68,12.73S46.82,64.62,33.9,57.13c-4.49,2.61-7,5.48-7,8.51,0,11.72,37.46,21.22,83.67,21.22s83.67-9.5,83.67-21.22C194.25,62.61,191.75,59.74,187.26,57.13Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin6);
export default __webpack_public_path__ + "static/media/coin6.5cf8de4eaeff854c7701a2c6798c1be5.svg";
export { ForwardRef as ReactComponent };